import { render, staticRenderFns } from "./TangoGQL.vue?vue&type=template&id=100325f0&scoped=true&"
import script from "./TangoGQL.vue?vue&type=script&lang=js&"
export * from "./TangoGQL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100325f0",
  null
  
)

export default component.exports